export default __webpack_public_path__ + "static/media/login.a0016b06.png";